export const FEATURES = {
  acceptLegalNotices: false,
};

export default FEATURES;
